import React, { FC } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { Box, ClickAwayListener } from '@material-ui/core';
import cx from 'classnames';
import sidebarStyle from './sidebarStyle';
import { ThemeBreakpoints } from 'common/ui/theme/default';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';
import { selectIsUserLoggedIn } from 'modules/authentication/state/selectors';
import AppService from 'services/application/AppService';
import useSidebarContext from 'common/hooks/context/useSidebarContext';
import MemberPortalSidebarRoutes from './MemberPortalSidebarRoutes';
import ClientPortalSidebarRoutes from './ClientPortalSidebarRoutes';
import ScrollBox from 'common/components/ScrollBox/ScrollBox';
import SidebarFilter from 'components/Sidebar/SidebarFilter';
import SidebarFooter from 'components/Sidebar/SidebarFooter';

const Sidebar: FC = () => {
  const classes = sidebarStyle();
  const { sidebarOpen, setSidebarOpen } = useSidebarContext();
  const memberPortalUserLogged = useRootSelector(selectIsMemberPortalUserLoggedIn);
  const clientPortalUserLogged = useRootSelector(selectIsUserLoggedIn);

  const closeSidebarOnClickOver = (e: React.MouseEvent<Document, MouseEvent>) => {
    if (window.innerWidth < ThemeBreakpoints.DESKTOP && sidebarOpen) {
      const hamburger = document.getElementById('hamburger');

      if (e.target instanceof Node && hamburger?.contains(e.target)) {
        return;
      }

      const newSidebarOpen = false;
      setSidebarOpen(newSidebarOpen);
      AppService.setAppSidebarOpen(newSidebarOpen);
      e.preventDefault();
    }
  };

  return (
    <>
      <ClickAwayListener
        touchEvent="onTouchEnd"
        mouseEvent="onMouseUp"
        onClickAway={closeSidebarOnClickOver}
      >
        <Box
          className={cx(`sidebar ${classes.root}`, {
            'sidebar--closed': !sidebarOpen,
          })}
          id="sidebarRoot"
          boxShadow={4}
          height="100%"
        >
          <Box flex={1} minHeight={0} display="flex" flexDirection="column">
            <Box className={classes.sidebarContainer}>
              <Box className={classes.header}>
                <SidebarFilter />
              </Box>

              <ScrollBox id="sidebarWrapper" className={classes.sidebarWrapper} suppressScrollX>
                {clientPortalUserLogged ? <ClientPortalSidebarRoutes /> : null}
                {memberPortalUserLogged ? <MemberPortalSidebarRoutes /> : null}
              </ScrollBox>

              <Box className={classes.footer}>
                <SidebarFooter />
              </Box>
            </Box>
          </Box>
        </Box>
      </ClickAwayListener>
    </>
  );
};

export default Sidebar;
